import { Tile } from '@sortlist-frontend/design-system';

import { RevealOnScroll } from '../components/RevealOnScroll';

interface TimelineProps {
  items: readonly { date: string; title: string; text: string }[];
}

export const Timeline = (props: TimelineProps) => {
  const { items } = props;

  return (
    <ol className="space-y-5 border-l-2 border-primary-200 pl-6">
      {items.map((item, index) => (
        <RevealOnScroll key={item.title} as="li" className="relative">
          <Tile
            size="sm"
            color="primary"
            variant="solid"
            radius="full"
            className="absolute -left-[2.35rem] top-1 font-semibold">
            {index + 1}
          </Tile>
          <div className="rounded-2xl border border-secondary-200 bg-white p-4 md:p-5">
            <p className="text-sm text-secondary-500">{item.date}</p>
            <p className="mt-1 text-lg font-bold text-secondary-950">{item.title}</p>
            <p className="mt-1 leading-relaxed text-secondary-700">{item.text}</p>
          </div>
        </RevealOnScroll>
      ))}
    </ol>
  );
};
